import { useCallback } from 'react';

import {
  ThreeDimensionalPicker,
  ThreeDimensionalPickerAnnotation
} from '@/components/three-dimensional-picker';
import { HomeInitialCapability } from '@/pages/home-page/state/constants';

interface HomePageCapabilitiesPickerProps {
  items: ThreeDimensionalPickerAnnotation[];
  onChange: (directionKey: string) => void;
  value: string;
}

export const HomePageCapabilitiesPicker = ({
  items,
  onChange,
  value = HomeInitialCapability
}: HomePageCapabilitiesPickerProps) => {
  const handlePickCapability = useCallback(
    ({ key }: ThreeDimensionalPickerAnnotation) => onChange(key),
    [onChange]
  );

  return (
    <div className="w-full max-w-[24rem] sm:max-w-[28rem] lg:max-w-[34rem] xl:max-w-[40rem] mx-auto lg:mx-0 px-12 sm:px-16 self-center lg:self-start">
      <div className="w-full aspect-square">
        <ThreeDimensionalPicker
          annotations={items}
          variant="sphere"
          value={value}
          onPickValue={handlePickCapability}
        />
      </div>
    </div>
  );
};
